export default __webpack_public_path__ + "static/media/x.10ede007.svg";